const createOverlay = (src) => {
    const overlay = document.createElement('div');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.position = 'absolute';
    overlay.style.inset = '0';
    overlay.style.background = 'rgba(0,0,0,0.6)';
    overlay.style.backdropFilter = 'blur(4px)';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.zIndex = '9';
    overlay.style.cursor = 'zoom-out';
    const img = document.createElement('img');
    img.src = src;
    img.alt = 'preview';
    img.style.maxWidth = '90%';
    img.style.maxHeight = '90%';
    img.style.objectFit = 'contain';
    img.style.borderRadius = '12px';
    img.style.boxShadow = '0 10px 40px rgba(0,0,0,0.35)';
    img.style.cursor = 'auto';
    // 进入动画
    overlay.animate([
        { opacity: 0 },
        { opacity: 1 }
    ], { duration: 120, easing: 'ease-out' });
    img.animate([
        { transform: 'scale(0.98)' },
        { transform: 'scale(1)' }
    ], { duration: 150, easing: 'ease-out' });
    overlay.appendChild(img);
    return { overlay, img };
};
const closeOverlay = (state) => {
    if (!state.overlayEl)
        return;
    const overlay = state.overlayEl;
    const fade = overlay.animate([
        { opacity: 1 },
        { opacity: 0 }
    ], { duration: 120, easing: 'ease-in' });
    fade.addEventListener('finish', () => {
        overlay.remove();
    });
    if (state.onKeydown) {
        window.removeEventListener('keydown', state.onKeydown);
    }
    state.overlayEl = null;
    state.imgEl = null;
};
const imgPreview = {
    mounted(el, binding) {
        // 标记状态
        const state = { overlayEl: null, imgEl: null, wrapperEl: null, btnEl: null };
        el.__imgPreviewState__ = state;
        // 包裹元素用于放置悬浮按钮
        const wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        // 统一用 inline-block，使包装尺寸与图片内容贴合，按钮可准确位于图片右下角
        wrapper.style.display = 'inline-block';
        wrapper.style.lineHeight = '0';
        wrapper.style.verticalAlign = 'top';
        wrapper.style.maxWidth = '100%';
        // 不修改尺寸，避免影响图片的自适应缩放
        const parent = el.parentNode;
        if (parent) {
            parent.insertBefore(wrapper, el);
            wrapper.appendChild(el);
        }
        state.wrapperEl = wrapper;
        // 悬浮放大按钮
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Preview');
        btn.style.position = 'absolute';
        // 将按钮相对于图片内容内边距定位
        btn.style.right = '6px';
        btn.style.bottom = '6px';
        btn.style.width = '32px';
        btn.style.height = '32px';
        btn.style.border = 'none';
        btn.style.borderRadius = '0';
        btn.style.background = 'transparent';
        btn.style.boxShadow = 'none';
        btn.style.padding = '0';
        btn.style.margin = '0';
        btn.style.color = 'inherit';
        btn.style.cursor = 'pointer';
        btn.style.display = 'flex';
        btn.style.alignItems = 'center';
        btn.style.justifyContent = 'center';
        btn.style.opacity = '0';
        btn.style.transition = 'opacity 0.15s ease';
        btn.style.pointerEvents = 'auto';
        btn.style.outline = 'none';
        btn.style.transform = 'translateZ(0)';
        // 使用项目内的 Vector.svg 作为按钮内容
        try {
            // 动态引入，兼容构建产物路径
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const vectorUrl = require('@/assets/images/Vector.svg');
            btn.innerHTML = `<img src="${vectorUrl}" alt="preview" style="width:33px;height:42px;display:block;"/>`;
        }
        catch {
            // 回退到内联 SVG，避免资源缺失导致按钮为空
            btn.innerHTML = '<svg width="16" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>';
        }
        wrapper.appendChild(btn);
        state.btnEl = btn;
        // hover 显示按钮
        wrapper.addEventListener('mouseenter', () => { btn.style.opacity = '1'; });
        wrapper.addEventListener('mouseleave', () => { btn.style.opacity = '0'; });
        // 不监听尺寸变化，减少对布局的影响
        const getSrc = () => {
            if (typeof binding.value === 'string' && binding.value)
                return binding.value;
            return el.currentSrc || el.src;
        };
        const open = () => {
            const src = getSrc();
            if (!src)
                return;
            const { overlay, img } = createOverlay(src);
            state.overlayEl = overlay;
            state.imgEl = img;
            const handleKeydown = (e) => {
                if (e.key === 'Escape')
                    closeOverlay(state);
            };
            state.onKeydown = handleKeydown;
            window.addEventListener('keydown', handleKeydown);
            // 点击遮罩关闭，并阻止冒泡到父级选择区域
            overlay.addEventListener('click', (evt) => {
                evt.stopPropagation();
                if (evt.target === overlay)
                    closeOverlay(state);
            });
            // 右上角关闭按钮
            const closeBtn = document.createElement('button');
            closeBtn.textContent = '✕';
            closeBtn.setAttribute('aria-label', 'Close');
            closeBtn.style.position = 'absolute';
            closeBtn.style.top = '16px';
            closeBtn.style.right = '16px';
            closeBtn.style.width = '36px';
            closeBtn.style.height = '36px';
            closeBtn.style.borderRadius = '18px';
            closeBtn.style.border = 'none';
            closeBtn.style.background = 'rgba(0,0,0,0.55)';
            closeBtn.style.color = '#fff';
            closeBtn.style.cursor = 'pointer';
            closeBtn.style.fontSize = '18px';
            closeBtn.style.lineHeight = '36px';
            closeBtn.addEventListener('click', () => closeOverlay(state));
            overlay.appendChild(closeBtn);
            // 将预览附加到最近的 .form-container 内部，限制不超出该容器
            let container = null;
            let cur = wrapper;
            while (cur) {
                if (cur.classList && cur.classList.contains('form-container')) {
                    container = cur;
                    break;
                }
                cur = cur.parentElement;
            }
            if (!container) {
                container = document.body;
                overlay.style.position = 'fixed';
                overlay.style.inset = '0';
            }
            else {
                // 在容器内绝对定位覆盖
                overlay.style.position = 'absolute';
                overlay.style.inset = '0';
            }
            container.appendChild(overlay);
        };
        // 放大按钮：阻止冒泡与默认行为，防止触发父级选择
        const onBtnClick = (e) => {
            e.stopPropagation();
            e.preventDefault();
            open();
        };
        btn.addEventListener('click', onBtnClick);
        // 防止按下/抬起也触发父级
        btn.addEventListener('mousedown', (e) => e.stopPropagation());
        btn.addEventListener('mouseup', (e) => e.stopPropagation());
        el.__imgPreviewCleanup__ = () => {
            btn.removeEventListener('click', onBtnClick);
            if (state.overlayEl)
                closeOverlay(state);
            // 无需移除尺寸监听
        };
    },
    beforeUnmount(el) {
        const cleanup = el.__imgPreviewCleanup__;
        if (cleanup)
            cleanup();
    }
};
export default imgPreview;
